// banners

const elementSelector = '.nav-cat-grid__container'
const paramKey1 = 'dep'
const paramValue1 = 'mens'
const paramKey2 = 'dep'
const paramValue2 = 'womens'
const defaultBannerScrollOffset = 95

function scrollToNavCatGrid(department) {
  // Find the nav-cat-grid container
  const navCatGridContainer = document.querySelector(elementSelector)
  if (!navCatGridContainer) return console.error('[scrollToNavCatGrid] Container not found')

  const inputValue = `mobile-nav-${department
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')}`

  const selectorInput =
    document.querySelector(
      `nav-cat-grid-selector .nav-cat-grid__selector__item input[value="${inputValue}"]`,
    ) ||
    document.querySelector(
      `nav-cat-grid-selector .nav-cat-grid__selector__item input[value="nav-cat-grid-men"]`,
    )

  if (selectorInput) {
    selectorInput.click()
  } else {
    console.error('[scrollToNavCatGrid] Err: Selector input not found')
  }

  // Scroll to the container
  setTimeout(() => {
    const headerWrapper = document.querySelector('main-nav')
    const yOffset = headerWrapper ? (headerWrapper.offsetHeight + 30) * -1 : -100
    const yCoordinate = navCatGridContainer.getBoundingClientRect().top + window.pageYOffset
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' })
  }, 100)
}

class DynamicBanner extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.init()
  }

  init() {
    if (this.dataset.scrollToElementSelector) {
      this.addEventListener('click', this.goToElement.bind(this))
    } else {
      this.setupScrollToElement()
    }
    this.setupVideoToggles()
  }

  // a11y: pause/play control for autoplaying banner videos (WCAG 2.2.2).
  // Toggles live outside the banner's wrapping <a> (no nested interactive
  // controls), so each one targets its video via data-video-target.
  setupVideoToggles() {
    this.querySelectorAll('[data-banner-video-toggle]').forEach((button) => {
      const target = button.dataset.videoTarget
      const video = target
        ? this.querySelector(`.banner__video-wrapper--${target} video`)
        : button.closest('.banner__video-wrapper')?.querySelector('video')
      if (!video) return
      button.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        const icon = button.querySelector('span')
        if (video.paused) {
          video.play()
          button.setAttribute('aria-label', button.dataset.pauseLabel || 'Pause video')
          if (icon) icon.innerHTML = '&#10074;&#10074;'
        } else {
          video.pause()
          button.setAttribute('aria-label', button.dataset.playLabel || 'Play video')
          if (icon) icon.innerHTML = '&#9654;'
        }
      })
    })
  }

  goToElement(event) {
    event.preventDefault()
    const offset = this.getScrollOffset()
    window.scrollToElementV2(this.dataset.scrollToElementSelector, offset)

    const categoryHandle = this.dataset.scrollToOpenCategoryHandle
    const menuItemProductUrl = this.dataset.scrollToOpenMenuItemUrl
    const productCardTitle = this.dataset.scrollToOpenProductCardTitle
    this.openMenuCategoryByHandle(
      categoryHandle,
      this.dataset.scrollToElementSelector,
      productCardTitle,
      menuItemProductUrl,
    )
    if (this.dataset.discountCode && this.dataset.autoApplyDiscount === 'true') {
      if (this.dataset.notificationShown) return
      this.dataset.notificationShown = 'true'
      showDiscountNotification(this.dataset.discountMessage)
    }
  }

  findMenuWithPdpElement(containerSelector = 'menu-with-pdp') {
    return window.findMenuWithPdpElement(containerSelector)
  }

  openMenuCategoryByHandle(
    categoryHandle,
    containerSelector = 'menu-with-pdp',
    productCardTitle = '',
    menuItemProductUrl = '',
  ) {
    return window.openMenuCategoryByHandle(
      categoryHandle,
      containerSelector,
      productCardTitle,
      menuItemProductUrl,
    )
  }

  setupScrollToElement() {
    const overlayLinks = this.querySelectorAll('.banner__overlay-link')
    const discountCode = this.dataset.discountCode
    const autoApplyDiscount = this.dataset.autoApplyDiscount === 'true'

    overlayLinks.forEach((link) => {
      const urlParamKey = link.dataset.urlParamKey
      const urlParamValue = link.dataset.urlParamValue
      const scrollSelector = link.dataset.scrollToElementSelector
      const scrollToOpenCategoryHandle =
        link.dataset.scrollToOpenCategoryHandle || this.dataset.scrollToOpenCategoryHandle
      const scrollToOpenMenuItemUrl =
        link.dataset.scrollToOpenMenuItemUrl || this.dataset.scrollToOpenMenuItemUrl
      const scrollToOpenProductCardTitle =
        link.dataset.scrollToOpenProductCardTitle || this.dataset.scrollToOpenProductCardTitle

      // Only hijack click if link has scroll selector data attribute
      if (!scrollSelector) return

      link.addEventListener('click', (e) => {
        e.preventDefault()

        // Handle discount code application
        if (discountCode && autoApplyDiscount) {
          if (this.isPromoCodeApplied(discountCode)) {
            showDiscountNotification(this.dataset.discountMessage)
          } else {
            this.applyDiscountCode(discountCode)
          }
        }

        // Scroll to element if selector provided
        if (scrollSelector) {
          window.scrollToElementV2(scrollSelector, this.getScrollOffset(link))
          this.openMenuCategoryByHandle(
            scrollToOpenCategoryHandle,
            scrollSelector,
            scrollToOpenProductCardTitle,
            scrollToOpenMenuItemUrl,
          )
        }

        // If it's a department parameter, scroll to nav-cat-grid
        if (urlParamKey === 'dep') {
          scrollToNavCatGrid(urlParamValue)
        }

        // Track analytics
        window.igEvents = window.igEvents || []
        window.igEvents.push({ event: 'Image Banner - Scroll To Click' })
      })
    })
  }

  getScrollOffset(element = this) {
    const desktopOffset =
      element.dataset.scrollToElementOffset || this.dataset.scrollToElementOffset
    const mobileOffset =
      element.dataset.scrollToElementOffsetMobile || this.dataset.scrollToElementOffsetMobile
    const offset = window.innerWidth < 768 ? mobileOffset || desktopOffset : desktopOffset

    if (offset === undefined || offset === '') return defaultBannerScrollOffset

    const parsedOffset = Number.parseFloat(offset)

    return Number.isNaN(parsedOffset) ? defaultBannerScrollOffset : parsedOffset
  }

  async applyDiscountCode(code) {
    if (this.dataset.notificationShown) return
    // this.dataset.notificationShown = 'true'
    showDiscountNotification(this.dataset.discountMessage)

    try {
      const response = await fetch(`${window.Shopify.routes.root}discount/${code}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })
      if (response.ok) {
        document.dispatchEvent(
          new CustomEvent('cartaddsuccess', { detail: { openCart: false, refreshCart: true } }),
        )
        const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString()
        document.cookie = `applied_promo=${code}; expires=${expires}; path=/`
        console.log(`${code} applied`)
      }
    } catch (error) {
      console.error('Discount apply error:', error)
    }
  }

  isPromoCodeApplied(promoCode) {
    if (!promoCode) return false
    const match = document.cookie.match(/applied_promo=([^;]+)/)
    return match && match[1].toUpperCase() === promoCode.toUpperCase()
  }
}

customElements.define('dynamic-banner', DynamicBanner)
